<template>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-8 col-lg-6 bg-white p-4">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
                <h4 class="text-third">
                    {{ accountActionTitle }}
                </h4>
                <span class="text-first text-decoration-underline" role="button" @click="onEdit = true" v-if="onEdit === false">
                    <i class="fa-regular fa-pen-to-square"></i>
                    {{ $t('Dashboard.Account.edit') }}
                </span>
            </div>
            <form @submit.prevent="applyChanges" v-if="onEdit !== null && onDelete === false">
                <div class="section-loader" v-if="onEdit === false">
                    <div class="border-bottom border-dark mb-4">
                        <span class="me-2">
                            {{ $t('Dashboard.Account.name') }}
                        </span>
                        <span class="fs-4">
                            {{ account.name }}
                        </span>
                    </div>
                    <div class="border-bottom border-dark mb-4">
                        <span class="me-2">
                            {{ $t('Dashboard.Account.surname') }}
                        </span>
                        <span class="fs-4">
                            {{ account.surname }}
                        </span>
                    </div>
                    <div class="border-bottom border-dark mb-4">
                        <span class="me-2">
                            {{ $t('Dashboard.Account.email') }}
                        </span>
                        <span class="text-break fs-4">
                            {{ account.email }}
                        </span>
                    </div>
                    <div class="mb-5">
                        <span class="me-2">
                            {{ $t('Dashboard.Account.language') }}
                        </span>
                        <span class="fs-4">
                            {{ $t(`${account.languages_id}`) }}
                        </span>
                    </div>
                    <div class="text-end">
                        <span class="btn btn-lg btn-danger" @click="onEdit = null, onDelete = true">
                            <i class="fa-regular fa-trash-can"></i>
                            {{ $t('Dashboard.Account.deletion_request') }}
                        </span>
                    </div>
                </div>
                <div class="section-loader" v-if="onEdit === true">
                    <div class="form-field mb-4">
                        <div class="field-wrapper">
                            <input type="text" v-model="name" id="name" :class="{'text-danger' : errors.name}" required>
                            <label for="name" :class="{'text-danger' : errors.name}">
                                {{ $t('Dashboard.Account.name') }}
                                <small class="text-danger" v-if="errors.name">
                                    <span class="mx-2">
                                        -
                                    </span>
                                    {{ errors.name }}
                                </small>
                            </label>
                        </div>
                    </div>
                    <div class="form-field mb-4">
                        <div class="field-wrapper">
                            <input type="text" v-model="surname" id="surname" :class="{'text-danger' : errors.surname}" required>
                            <label for="surname" :class="{'text-danger' : errors.surname}">
                                {{ $t('Dashboard.Account.surname') }}
                                <small class="text-danger" v-if="errors.surname">
                                    <span class="mx-2">
                                        -
                                    </span>
                                    {{ errors.surname }}
                                </small>
                            </label>
                        </div>
                    </div>
                    <div class="form-field mb-4">
                        <div class="field-wrapper disabled">
                            <input name="email" type="email" :value="account.email" id="email" disabled>
                            <label for="email">
                                {{ $t('Dashboard.Account.email') }}
                            </label>
                        </div>
                    </div>
                    <div class="form-field ps-2 mb-5">
                        <LanguagesSelect id="language" @setLanguage="errors = {}"/>
                    </div>
                    <div class="d-flex justify-content-between align-items-center flex-wrap text-end">
                        <span class="text-first text-decoration-underline" role="button" @click="cancel">
                            {{ $t('Dashboard.EditAccountData.cancel') }}
                        </span>
                        <button type="submit" class="btn btn-lg btn-auth btn-auth-first">
                            {{ $t('Dashboard.EditAccountData.apply') }}
                        </button>
                    </div>
                </div>
            </form>
            <form @submit.prevent="sendDeletionRequest" class="section-loader" v-if="onEdit === null && onDelete === true">
                <h5 class="text-danger mb-5">
                    {{ $t('Dashboard.DeletionRequest.notice') }}
                </h5>
                <div class="d-flex justify-content-center justify-content-sm-between align-items-center flex-wrap">
                    <span class="text-first text-decoration-underline mb-4 mb-sm-0" role="button" @click="onEdit = false, onDelete = false">
                        {{ $t('Dashboard.DeletionRequest.cancel') }}
                    </span>
                    <button type="submit" class="btn btn-lg btn-danger">
                        {{ $t('Dashboard.DeletionRequest.send_request') }}
                    </button>
                </div>
            </form>
            <form @submit.prevent="deletionConfirm" class="section-loader" v-if="onEdit === null && onDelete === 'on delete'">
                <h5 class="mb-4">
                    {{ $t('Dashboard.DeletionConfirm.otp_sended') }}
                    <span class="text-first text-break fs-5">
                        {{ account.email }}
                    </span>
                </h5>
                <div class="form-field mb-5">
                    <div class="field-wrapper">
                        <input type="text" v-model="OTP" id="OTP" :class="{'text-danger' : errors.OTP}" @focus="errors.OTP = null" maxlength="6" required>
                        <label for="OTP" :class="{'text-danger' : errors.OTP}">
                            {{ $t('Dashboard.DeletionConfirm.otp') }}
                            <small class="text-danger" v-if="errors.OTP">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.OTP }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="text-center mb-5">
                    <span class="text-danger text-uppercase">
                        {{ $t('Dashboard.DeletionConfirm.alert') }}
                    </span>
                </div>
                <div class="d-flex justify-content-center justify-content-sm-between align-items-center flex-wrap">
                    <span class="text-first text-decoration-underline mb-4 mb-sm-0" role="button" @click="onEdit = false, onDelete = false">
                        {{ $t('Dashboard.DeletionRequest.cancel') }}
                    </span>
                    <button type="submit" class="btn btn-lg btn-danger">
                        {{ $t('Dashboard.DeletionConfirm.confirm') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import LanguagesSelect from '@/components/LanguagesSelect.vue'
export default {
    name: 'AccountView',
    components: {
        LanguagesSelect
    },
    computed: {
        ...mapState(['account']),
        ...mapGetters(['apiPath', 'omsApiKey']),
        accountActionTitle() {
            var default_title = this.$t('Dashboard.Account.personal_data')
            
            if (this.onEdit) return `${this.$t('Dashboard.EditAccountData.edit')} - ${default_title}`
            if (this.onDelete === true) return `${this.$t('Dashboard.DeletionRequest.request')} - ${default_title}`
            if (this.onDelete === 'on delete') return `${this.$t('Dashboard.DeletionRequest.request')} - ${default_title}`
            return default_title
        }
    },
    data() {
        return {
            onEdit: false,
            onDelete: false,
            name: null,
            surname: null,
            OTP: null,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer', 'setAccount', 'setLoader']),
        cancel() {
            this.errors = {}
            if (this.account.name !== this.name) {
                this.name = this.account.name
            }
            if (this.account.surname !== this.surname) {
                this.surname = this.account.surname
            }
            if (this.account.languages_id !== this.$i18n.locale) {
                this.$i18n.locale = this.account.languages_id
                localStorage.setItem('session_language', this.account.languages_id)
            }
            this.onEdit = false
        },
        applyChanges() {
            this.setLoader(true)
            this.errors = {}
            var account = {
                id: this.account.id,
                name: this.name,
                surname: this.surname,
                language: this.$i18n.locale,
                notify_ticket_issuance: true
            }

            this.$http
                .post(`${this.apiPath}/edit`, { account }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    this.setLoader(false)
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'account.name') {
                                this.errors.name = this.$t(`Dashboard.EditAccountData.errors.name.${error.msg}`)
                            }
                            if (error.path == 'account.surname') {
                                this.errors.surname = this.$t(`Dashboard.EditAccountData.errors.surname.${error.msg}`)
                            }
                            if (error.path == 'account.language') {
                                this.errors.language = this.$t(`Dashboard.EditAccountData.errors.language.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    if (res.data.account) {
                        this.setAccount(res.data.account)
                        this.$toast.success(this.$t('Dashboard.AccountDataChangesSucceeded.succeeded'))
                        this.onEdit = false
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                    this.setLoader(false)
                })
        },
        sendDeletionRequest() {
            this.onDelete = 'on delete'
            this.$http
                .post(`${this.apiPath}/deletion_request`, { id: this.account.id }, {
                    headers: {
                        "x-api-key": this.omsApiKey,
                    }
                })
                .then(() => {
                    this.$toast.success(this.$t('toast.deletion_request_sended'))
                })
                .catch((err) => {
                    this.setErrorFromServer(err)
                })
        },
        deletionConfirm() {
            this.setLoader(true)
            this.$http
                .post(`${this.apiPath}/deletion_confirm`, { id: this.account.id, OTP: this.OTP }, {
                    headers: {
                        "x-api-key": this.omsApiKey,
                    }
                })
                .then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'OTP') {
                                this.errors.OTP = this.$t(`Dashboard.DeletionConfirm.errors.OTP.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        this.setLoader(false)
                        return
                    }
                    switch (res.data) {
                        case 'Invalid OTP':
                            this.errors.OTP = this.$t('Dashboard.DeletionConfirm.errors.OTP.invalid')
                            this.$toast.error(this.$t('Dashboard.DeletionConfirm.errors.OTP.invalid'))
                            this.setLoader(false)
                            break;
                        default:
                            this.$toast.success(`<h4>${this.$t('Dashboard.AccountDeleted.deleted')}</h4> ${this.$t('Dashboard.AccountDeleted.disconnection')}`)
                            setTimeout(() => {
                                this.$store.dispatch('logout')
                            }, 1500)
                            break;
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err)
                })
        }
    },
    created() {
        this.name = this.account.name
        this.surname = this.account.surname
    }
}
</script>

<style lang="scss" scoped>
    .section-loader {
        animation: loading 0.5s linear;

        @keyframes loading {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    }
</style>